import React from 'react';
import { Link } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import {
  Typography,
   Card,
  CardContent,
  Grid,
}
  from '@mui/material'

const useStyles = makeStyles({
  root: {
    minWidth: 275,
    height: '200px',
    margin: '10px',
    backgroundColor: '#1976d2', 
    color: '#ffffff',
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 25,
    color: '#ffffff',
  },
  pos: {
    marginBottom: 12,
  },
  Button: {
    color: '#ffffff',
  },
  cardContent: {
    '& > * + *': {
      marginTop: '10px', 
    },
  },
});

const theme = createTheme({
  typography: {
    fontSize: 18, 
  },
  palette: {
    primary: {
      main: '#1976d2', 
    },
    text: {
      primary: '#ffffff', 
    },
  },
});

const HomePage = () => {

  const classes = useStyles();
 

  return (
    <ThemeProvider theme={theme}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={4}>
          <Link to="/empleados" className="link">
            <Card className={classes.root} variant="outlined">
              <CardContent>
                <Typography className={classes.title} color="textSecondary" gutterBottom>
                  GESTIÓN DE EMPLEADOS
                </Typography>


                <Typography variant="body2" component="h3">
                 
                  <br />
                  - Ingresá nuevos empleados.
                  <br />
                  - Editá información de empleados.
                  <br />

                </Typography>
              </CardContent>

            </Card>
          </Link>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Link to="/clientes" className="link">
            <Card className={classes.root} variant="outlined">
              <CardContent>
                <Typography className={classes.title} color="textSecondary" gutterBottom>
                  CLIENTES
                </Typography>
                <Typography variant="body2" component="h3">
                  - Listado de Clientes.
                  <br />
                  - Ver detalles de contratos.
                  <br />
                  - Ver estados de servicios.
                  <br />
                  -Ver información de contacto
                </Typography>
              </CardContent>

            </Card>
          </Link>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Link to="/tareas" className="link">
            <Card className={classes.root} variant="outlined">
              <CardContent>
                <Typography className={classes.title} color="textSecondary" gutterBottom>
                  TAREAS
                </Typography>
                <Typography variant="body2" component="h3">
                  - Asignar tareas.
                  <br />
                  - Asignar turnos de trabajo.
                  <br />
                  - Ver calendario.
                  <br />
                  - Ver Tickets pendientes.

                </Typography>
              </CardContent>

            </Card>
          </Link>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Link to="/caja" className="link">
            <Card className={classes.root} variant="outlined">
              <CardContent>
                <Typography className={classes.title} color="textSecondary" gutterBottom>
                  CAJA - FACTURACIÓN
                </Typography>
                <Typography variant="body2" component="h3">
                  - Carga Facturas Dataico.
                  <br />
                  - Movimientos de caja.
                  <br />
                  - Facturas carga masiva.
                  


                </Typography>
              </CardContent>

            </Card>
          </Link>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Link to="/comprobantes" className="link">
            <Card className={classes.root} variant="outlined">
              <CardContent>
                <Typography className={classes.title} color="textSecondary" gutterBottom>
                  ACTUALIZACIONES
                </Typography>
                <Typography variant="body2" component="h3">
                  - Comprobantes.
                  <br />
                  - Editá información de contratos.
                  <br />
                  -Cargar descuentos o retenciones.
                  <br />
                  -Cargar Promociones.

                </Typography>
              </CardContent>

            </Card>
          </Link>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Link to="/contratosPendientes" className="link">
            <Card className={classes.root} variant="outlined">
              <CardContent>
                <Typography className={classes.title} color="textSecondary" gutterBottom>
                  CONTRATOS PENDIENTES
                </Typography>
                <Typography variant="body2" component="h3">
                  - Contratos pendientes de confirmación.
                  <br />
                  - Contratos en promoción.
                </Typography>
              </CardContent>

            </Card>
          </Link>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}

export default HomePage;
